import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

export type PeriodKey = "this" | "last" | "last3" | "custom";

interface PeriodOption {
  value: PeriodKey;
  label: string;
}

interface FilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  period: PeriodKey;
  onPeriodChange: (value: PeriodKey) => void;
  periodOptions: PeriodOption[];
}

export default function FilterBar({
  search,
  onSearchChange,
  searchPlaceholder,
  period,
  onPeriodChange,
  periodOptions,
}: FilterBarProps) {
  return (
    <div className="rounded-[12px] border border-[var(--border-color)] bg-[var(--bg-secondary)] px-4 py-3">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex min-w-[220px] flex-1 items-center gap-2 rounded-[8px] border border-[var(--border-color)] bg-[var(--bg-deep)] px-3 py-2">
          <Search size={14} className="text-[var(--text-muted)]" />
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="h-[20px] w-full border-0 bg-transparent text-[13px] font-normal text-[var(--text-primary)] outline-none placeholder:text-[var(--text-muted)]"
            placeholder={searchPlaceholder}
          />
        </div>

        <div
          className="inline-flex flex-wrap gap-[2px] rounded-[10px] border border-[var(--border-color)] bg-[var(--bg-secondary)] p-[3px]"
          role="tablist"
          aria-label="Period"
        >
          {periodOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              role="tab"
              aria-selected={period === option.value}
              className={cn(
                "rounded-[7px] px-[14px] py-[6px] text-[12px] font-normal text-[var(--text-secondary)] transition-all [transition-duration:150ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
                period === option.value && "bg-[var(--bg-hover)] text-[var(--text-primary)] shadow-[0_1px_2px_rgba(0,0,0,0.2)]",
              )}
              onClick={() => onPeriodChange(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
